"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FakeSuperfluidMock__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "agreement",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "callData",
                type: "bytes",
            },
        ],
        name: "callAgreement",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "0x608060405234801561001057600080fd5b50610314806100206000396000f3fe608060405234801561001057600080fd5b506004361061002b5760003560e01c806361d164d314610030575b600080fd5b61004361003e3660046101d9565b610045565b005b60006060846001600160a01b0316848460405161006392919061026a565b6000604051808303816000865af19150503d80600081146100a0576040519150601f19603f3d011682016040523d82523d6000602084013e6100a5565b606091505b50909250905081156100b9576100b961027a565b6100c2816100c9565b5050505050565b6004815110156101205760405162461bcd60e51b815260206004820152601a60248201527f43616c6c5574696c733a2074617267657420726576657274282900000000000060448201526064015b60405180910390fd5b602081015163b1b7848f60e01b6001600160e01b03198216016101d05760408051808201825260208082527f43616c6c5574696c733a207461726765742070616e69636b65643a2030785f5f90820190815260248501517f43616c6c5574696c733a207461726765742070616e69636b65643a2030780000600482811c600f908116603090810160081b918516011791909117909252925162461bcd60e51b815291929161011791849101610290565b81518060208401fd5b6000806000604084860312156101ee57600080fd5b83356001600160a01b038116811461020557600080fd5b9250602084013567ffffffffffffffff8082111561022257600080fd5b818601915086601f83011261023657600080fd5b81358181111561024557600080fd5b87602082850101111561025757600080fd5b6020830194508093505050509250925092565b8183823760009101908152919050565b634e487b7160e01b600052600160045260246000fd5b600060208083528351808285015260005b818110156102bd578581018301518582016040015282016102a1565b506000604082860101526040601f19601f830116850101925050509291505056fea26469706673582212209d360f024e9bcde14faf54596b72496b7d884b56b3771c8f298db2cef034742764736f6c63430008100033";
const isSuperArgs = (xs) => xs.length > 1;
class FakeSuperfluidMock__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.FakeSuperfluidMock__factory = FakeSuperfluidMock__factory;
FakeSuperfluidMock__factory.bytecode = _bytecode;
FakeSuperfluidMock__factory.abi = _abi;
//# sourceMappingURL=FakeSuperfluidMock__factory.js.map